import { 
    getTransferItemAndOrderLevelApproval,
    getTransferApproverActionData
 } from "./TransferApprovalAction";

const dispatchTransferItemAndOrderLevelApproval = (dispatch: Function) => (val : any) => {
    dispatch(getTransferItemAndOrderLevelApproval(val));
};

const dispatchTransferGetApproverActionData = (dispatch: Function) => () => {
    dispatch(getTransferApproverActionData());
};

const ApprovalDispatch = {
    dispatchTransferItemAndOrderLevelApproval,
    dispatchTransferGetApproverActionData
};

export default ApprovalDispatch